import { useMemo } from 'react';
import { useAccount } from '../contexts/AccountContext';

export function useComplianceRole() {
  const { user, hasPermission } = useAccount();

  return useMemo(() => {
    const isCO = user?.role === 'compliance_officer';
    const isRM = user?.role === 'advisor';
    const isAdmin = user?.role === 'admin';

    // CO sees: Dashboard (filtered), Compliance, Documents, Tasks
    // CO does NOT see: Portfolio, Client Profile forms, Form A, Risk Profile
    const visibleTabs = isCO
      ? ['overview', 'screening', 'transactions', 'risk-rating']
      : ['overview', 'forms', 'screening', 'transactions', 'risk-rating'];

    const visibleForms = isCO
      ? ['kyc']
      : ['kyc', 'riskProfile', 'clientProfile', 'formA'];

    const canReviewKYC = isCO || isAdmin || hasPermission('kyc:review');
    const canApproveKYC = isCO || isAdmin || hasPermission('kyc:approve');
    const canRequestDocuments = isCO || isRM || isAdmin || hasPermission('document_requests:create');

    return {
      isCO,
      isRM,
      isAdmin,
      visibleTabs,
      visibleForms,
      canReviewKYC,
      canApproveKYC,
      canRequestDocuments,
    };
  }, [user, hasPermission]);
}
